/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type PricingGridRendererQueryVariables = {
    orgRelayId: string;
};
export type PricingGridRendererQueryResponse = {
    readonly org: {
        readonly id?: string | undefined;
        readonly experiments?: ReadonlyArray<string | null> | null | undefined;
        readonly " $fragmentRefs": FragmentRefs<"OrgPricingGrid_org">;
    } | null;
};
export type PricingGridRendererQuery = {
    readonly response: PricingGridRendererQueryResponse;
    readonly variables: PricingGridRendererQueryVariables;
};



/*
query PricingGridRendererQuery(
  $orgRelayId: ID!
) {
  org: node(id: $orgRelayId) {
    __typename
    ... on Org {
      ...OrgPricingGrid_org
      id
      experiments
    }
    id
  }
}

fragment AvatarPerson_org on Org {
  id
}

fragment AvatarPerson_orgPerson on OrgPerson {
  __typename
  id
  primaryCalendarId
  isYou
  userId
  profile {
    givenName
    familyName
    externalImageUrl
  }
}

fragment AvatarRowNew_org on Org {
  ...AvatarPerson_org
}

fragment OrgPricingGrid_org on Org {
  ...TeamJoinCreateDialog_org
  id
  experiments
  orgAccountingPeriod {
    __typename
    ... on OrgAccountingPeriod {
      periodRange {
        minDate
        maxDate
      }
      quotaMax
      quotaUsed
      enforcementState
    }
    ... on GraphEntityError {
      message
      statusCode
    }
  }
  billingGroups {
    __typename
    ... on BillingGroupList {
      list {
        id
        name
        subscription {
          __typename
          ... on SubscriptionDetails {
            subscription {
              productType
              id
            }
          }
          ... on GraphEntityError {
            message
            statusCode
          }
        }
      }
    }
    ... on GraphEntityError {
      message
      statusCode
    }
  }
  featureGrid {
    __typename
    ... on FeatureGrid {
      stateMetadata {
        primaryBillingGroupMetadata {
          subscription {
            id
            type
            productType
          }
        }
      }
    }
    ... on GraphEntityError {
      statusCode
      message
    }
  }
}

fragment TeamJoinCreateDialog_org on Org {
  ...TeamJoinCreate_org
  id
  primaryOrgCalendar
}

fragment TeamJoinCreate_org on Org {
  ...AvatarRowNew_org
  ...TeamSettingsSearch_org
  ...TeamSearchInputRenderer_org
  id
  primaryOrgCalendar
  orgPersonForUserErrorable {
    __typename
    ... on OrgPerson {
      personId
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  primaryTeam {
    __typename
    ... on Team {
      teamId
      teamName
    }
    ... on GraphEntityError {
      statusCode
      message
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  billingGroups {
    __typename
    ... on BillingGroupList {
      list {
        id
        name
        syncSources {
          type
          value
          id
        }
        subscription {
          __typename
          ... on SubscriptionDetails {
            subscription {
              id
              productType
            }
          }
          ... on GraphEntityError {
            message
            statusCode
          }
        }
      }
    }
    ... on GraphEntityError {
      message
      statusCode
    }
  }
  userTeams {
    __typename
    ... on TeamList {
      list {
        id
        teamId
        teamName
        createdBy {
          value
          id
        }
        teamCalendarId
        settings {
          __typename
          ... on TeamSettings {
            manageTeamCalendar
          }
          ... on Node {
            __isNode: __typename
            id
          }
        }
        userSettings {
          __typename
          ... on TeamUserSettings {
            useTeamCalendar
          }
          ... on Node {
            __isNode: __typename
            id
          }
        }
        teamMembers {
          person {
            ...AvatarPerson_orgPerson
            personId
            primaryCalendarId
            isYou
            profile {
              givenName
              familyName
            }
            id
          }
        }
        invitedMembers {
          person {
            ...AvatarPerson_orgPerson
            personId
            primaryCalendarId
            isYou
            profile {
              givenName
              familyName
            }
            id
          }
        }
      }
    }
  }
  suggestedTeams {
    __typename
    ... on SuggestedTeamList {
      list {
        team {
          id
          teamId
          teamName
          createdBy {
            value
            id
          }
          teamMembers {
            person {
              ...AvatarPerson_orgPerson
              personId
              primaryCalendarId
              isYou
              profile {
                givenName
                familyName
              }
              id
            }
          }
          invitedMembers {
            person {
              ...AvatarPerson_orgPerson
              personId
              primaryCalendarId
              isYou
              profile {
                givenName
                familyName
              }
              id
            }
          }
        }
        reasons {
          type
          value
        }
        score
      }
    }
  }
}

fragment TeamSearchInputRenderer_org on Org {
  id
}

fragment TeamSettingsSearch_org on Org {
  ...TeamSettingsTeammate_org
  id
  primaryOrgCalendar
  workingGroups(first: 1000000) {
    edges {
      node {
        calendarIds
        id
      }
    }
  }
}

fragment TeamSettingsTeammate_org on Org {
  ...AvatarPerson_org
  id
  primaryOrgEmail
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "orgRelayId"
        } as any
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "orgRelayId"
        } as any
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "experiments",
        "storageKey": null
    } as any, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "personId",
        "storageKey": null
    } as any, v6 = {
        "kind": "InlineFragment",
        "selections": [
            (v2 /*: any*/)
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "teamId",
        "storageKey": null
    } as any, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "teamName",
        "storageKey": null
    } as any, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "statusCode",
        "storageKey": null
    } as any, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    } as any, v11 = {
        "kind": "InlineFragment",
        "selections": [
            (v9 /*: any*/),
            (v10 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v12 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
    } as any, v13 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
    } as any, v14 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "productType",
        "storageKey": null
    } as any, v15 = {
        "kind": "InlineFragment",
        "selections": [
            (v10 /*: any*/),
            (v9 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v16 = {
        "alias": null,
        "args": null,
        "concreteType": "Urn",
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": [
            (v13 /*: any*/),
            (v2 /*: any*/)
        ],
        "storageKey": null
    } as any, v17 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "OrgPerson",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": [
                (v4 /*: any*/),
                (v2 /*: any*/),
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "primaryCalendarId",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isYou",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userId",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserProfile",
                    "kind": "LinkedField",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "givenName",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "familyName",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "externalImageUrl",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                (v5 /*: any*/)
            ],
            "storageKey": null
        } as any
    ], v18 = {
        "alias": null,
        "args": null,
        "concreteType": "TeamMember",
        "kind": "LinkedField",
        "name": "teamMembers",
        "plural": true,
        "selections": (v17 /*: any*/),
        "storageKey": null
    } as any, v19 = {
        "alias": null,
        "args": null,
        "concreteType": "TeamMember",
        "kind": "LinkedField",
        "name": "invitedMembers",
        "plural": true,
        "selections": (v17 /*: any*/),
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "PricingGridRendererQuery",
            "selections": [
                {
                    "alias": "org",
                    "args": (v1 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/),
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "OrgPricingGrid_org"
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "PricingGridRendererQuery",
            "selections": [
                {
                    "alias": "org",
                    "args": (v1 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v4 /*: any*/),
                        (v2 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "primaryOrgEmail",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "primaryOrgCalendar",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 1000000
                                        }
                                    ],
                                    "concreteType": "WorkingGroupConnection",
                                    "kind": "LinkedField",
                                    "name": "workingGroups",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "WorkingGroupEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "WorkingGroup",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "calendarIds",
                                                            "storageKey": null
                                                        },
                                                        (v2 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "workingGroups(first:1000000)"
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "orgPersonForUserErrorable",
                                    "plural": false,
                                    "selections": [
                                        (v4 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v5 /*: any*/)
                                            ],
                                            "type": "OrgPerson",
                                            "abstractKey": null
                                        },
                                        (v6 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "primaryTeam",
                                    "plural": false,
                                    "selections": [
                                        (v4 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v7 /*: any*/),
                                                (v8 /*: any*/)
                                            ],
                                            "type": "Team",
                                            "abstractKey": null
                                        },
                                        (v11 /*: any*/),
                                        (v6 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "billingGroups",
                                    "plural": false,
                                    "selections": [
                                        (v4 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "BillingGroup",
                                                    "kind": "LinkedField",
                                                    "name": "list",
                                                    "plural": true,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "name",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Urn",
                                                            "kind": "LinkedField",
                                                            "name": "syncSources",
                                                            "plural": true,
                                                            "selections": [
                                                                (v12 /*: any*/),
                                                                (v13 /*: any*/),
                                                                (v2 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "subscription",
                                                            "plural": false,
                                                            "selections": [
                                                                (v4 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "PaymentSubscription",
                                                                            "kind": "LinkedField",
                                                                            "name": "subscription",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v2 /*: any*/),
                                                                                (v14 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "SubscriptionDetails",
                                                                    "abstractKey": null
                                                                },
                                                                (v15 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "BillingGroupList",
                                            "abstractKey": null
                                        },
                                        (v15 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "userTeams",
                                    "plural": false,
                                    "selections": [
                                        (v4 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Team",
                                                    "kind": "LinkedField",
                                                    "name": "list",
                                                    "plural": true,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        (v7 /*: any*/),
                                                        (v8 /*: any*/),
                                                        (v16 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "teamCalendarId",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "settings",
                                                            "plural": false,
                                                            "selections": [
                                                                (v4 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "manageTeamCalendar",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "TeamSettings",
                                                                    "abstractKey": null
                                                                },
                                                                (v6 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "userSettings",
                                                            "plural": false,
                                                            "selections": [
                                                                (v4 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "useTeamCalendar",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "TeamUserSettings",
                                                                    "abstractKey": null
                                                                },
                                                                (v6 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v18 /*: any*/),
                                                        (v19 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "TeamList",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "suggestedTeams",
                                    "plural": false,
                                    "selections": [
                                        (v4 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "SuggestedTeam",
                                                    "kind": "LinkedField",
                                                    "name": "list",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Team",
                                                            "kind": "LinkedField",
                                                            "name": "team",
                                                            "plural": false,
                                                            "selections": [
                                                                (v2 /*: any*/),
                                                                (v7 /*: any*/),
                                                                (v8 /*: any*/),
                                                                (v16 /*: any*/),
                                                                (v18 /*: any*/),
                                                                (v19 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "SuggestedTeamReason",
                                                            "kind": "LinkedField",
                                                            "name": "reasons",
                                                            "plural": true,
                                                            "selections": [
                                                                (v12 /*: any*/),
                                                                (v13 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "score",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "SuggestedTeamList",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                (v3 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "orgAccountingPeriod",
                                    "plural": false,
                                    "selections": [
                                        (v4 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "DateRange",
                                                    "kind": "LinkedField",
                                                    "name": "periodRange",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "minDate",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "maxDate",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "quotaMax",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "quotaUsed",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "enforcementState",
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "OrgAccountingPeriod",
                                            "abstractKey": null
                                        },
                                        (v15 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "featureGrid",
                                    "plural": false,
                                    "selections": [
                                        (v4 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "PaymentStateMetadata",
                                                    "kind": "LinkedField",
                                                    "name": "stateMetadata",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "PrimaryBillingGroupMetadata",
                                                            "kind": "LinkedField",
                                                            "name": "primaryBillingGroupMetadata",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "PaymentSubscription",
                                                                    "kind": "LinkedField",
                                                                    "name": "subscription",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v2 /*: any*/),
                                                                        (v12 /*: any*/),
                                                                        (v14 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "FeatureGrid",
                                            "abstractKey": null
                                        },
                                        (v11 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "aa1ef017a87ba4d0f7e943d17b234964",
            "id": null,
            "metadata": {},
            "name": "PricingGridRendererQuery",
            "operationKind": "query",
            "text": "query PricingGridRendererQuery(\n  $orgRelayId: ID!\n) {\n  org: node(id: $orgRelayId) {\n    __typename\n    ... on Org {\n      ...OrgPricingGrid_org\n      id\n      experiments\n    }\n    id\n  }\n}\n\nfragment AvatarPerson_org on Org {\n  id\n}\n\nfragment AvatarPerson_orgPerson on OrgPerson {\n  __typename\n  id\n  primaryCalendarId\n  isYou\n  userId\n  profile {\n    givenName\n    familyName\n    externalImageUrl\n  }\n}\n\nfragment AvatarRowNew_org on Org {\n  ...AvatarPerson_org\n}\n\nfragment OrgPricingGrid_org on Org {\n  ...TeamJoinCreateDialog_org\n  id\n  experiments\n  orgAccountingPeriod {\n    __typename\n    ... on OrgAccountingPeriod {\n      periodRange {\n        minDate\n        maxDate\n      }\n      quotaMax\n      quotaUsed\n      enforcementState\n    }\n    ... on GraphEntityError {\n      message\n      statusCode\n    }\n  }\n  billingGroups {\n    __typename\n    ... on BillingGroupList {\n      list {\n        id\n        name\n        subscription {\n          __typename\n          ... on SubscriptionDetails {\n            subscription {\n              productType\n              id\n            }\n          }\n          ... on GraphEntityError {\n            message\n            statusCode\n          }\n        }\n      }\n    }\n    ... on GraphEntityError {\n      message\n      statusCode\n    }\n  }\n  featureGrid {\n    __typename\n    ... on FeatureGrid {\n      stateMetadata {\n        primaryBillingGroupMetadata {\n          subscription {\n            id\n            type\n            productType\n          }\n        }\n      }\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n  }\n}\n\nfragment TeamJoinCreateDialog_org on Org {\n  ...TeamJoinCreate_org\n  id\n  primaryOrgCalendar\n}\n\nfragment TeamJoinCreate_org on Org {\n  ...AvatarRowNew_org\n  ...TeamSettingsSearch_org\n  ...TeamSearchInputRenderer_org\n  id\n  primaryOrgCalendar\n  orgPersonForUserErrorable {\n    __typename\n    ... on OrgPerson {\n      personId\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  primaryTeam {\n    __typename\n    ... on Team {\n      teamId\n      teamName\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  billingGroups {\n    __typename\n    ... on BillingGroupList {\n      list {\n        id\n        name\n        syncSources {\n          type\n          value\n          id\n        }\n        subscription {\n          __typename\n          ... on SubscriptionDetails {\n            subscription {\n              id\n              productType\n            }\n          }\n          ... on GraphEntityError {\n            message\n            statusCode\n          }\n        }\n      }\n    }\n    ... on GraphEntityError {\n      message\n      statusCode\n    }\n  }\n  userTeams {\n    __typename\n    ... on TeamList {\n      list {\n        id\n        teamId\n        teamName\n        createdBy {\n          value\n          id\n        }\n        teamCalendarId\n        settings {\n          __typename\n          ... on TeamSettings {\n            manageTeamCalendar\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        userSettings {\n          __typename\n          ... on TeamUserSettings {\n            useTeamCalendar\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        teamMembers {\n          person {\n            ...AvatarPerson_orgPerson\n            personId\n            primaryCalendarId\n            isYou\n            profile {\n              givenName\n              familyName\n            }\n            id\n          }\n        }\n        invitedMembers {\n          person {\n            ...AvatarPerson_orgPerson\n            personId\n            primaryCalendarId\n            isYou\n            profile {\n              givenName\n              familyName\n            }\n            id\n          }\n        }\n      }\n    }\n  }\n  suggestedTeams {\n    __typename\n    ... on SuggestedTeamList {\n      list {\n        team {\n          id\n          teamId\n          teamName\n          createdBy {\n            value\n            id\n          }\n          teamMembers {\n            person {\n              ...AvatarPerson_orgPerson\n              personId\n              primaryCalendarId\n              isYou\n              profile {\n                givenName\n                familyName\n              }\n              id\n            }\n          }\n          invitedMembers {\n            person {\n              ...AvatarPerson_orgPerson\n              personId\n              primaryCalendarId\n              isYou\n              profile {\n                givenName\n                familyName\n              }\n              id\n            }\n          }\n        }\n        reasons {\n          type\n          value\n        }\n        score\n      }\n    }\n  }\n}\n\nfragment TeamSearchInputRenderer_org on Org {\n  id\n}\n\nfragment TeamSettingsSearch_org on Org {\n  ...TeamSettingsTeammate_org\n  id\n  primaryOrgCalendar\n  workingGroups(first: 1000000) {\n    edges {\n      node {\n        calendarIds\n        id\n      }\n    }\n  }\n}\n\nfragment TeamSettingsTeammate_org on Org {\n  ...AvatarPerson_org\n  id\n  primaryOrgEmail\n}\n"
        }
    } as any;
})();
(node as any).hash = '853e6ed69944134ee1831dcfc02f8a2f';
export default node;
